import { useCallback, useMemo } from 'react';

import { INSIGHT_VIEWS } from 'reducers/okrsPageSlice';
import { useSelectedView } from 'reducers/viewsSlice';
import { useOKRGroupByViewType } from 'screens/Team/Rabbit/Goals/AgGridTreeView/hooks/useOKRGroupByViewType';
import {
  OKRManageViewType,
  useOKRManageViewType,
} from 'screens/Team/Rabbit/Goals/AgGridTreeView/hooks/useOKRManageViewType';

import { CardView, FlatList, TreeView } from 'assets/assetsV1/iconComponents';
import { CascadedList } from 'assets/assetsV1/iconComponents/CascadedList';

import { isNetchexLogin } from 'constants/netChexConstants';

export const useOKRViewTypeValues = () => {
  const { setViewType } = useOKRManageViewType();
  const { id: selectedCohortId, name } = useSelectedView() ?? {};
  const isCheckInView = name === 'Check-in';
  // const { viewType: groupByType } = useOKRInsights();
  const { groupByViewType } = useOKRGroupByViewType();

  const isGroupByIndividual = groupByViewType === INSIGHT_VIEWS[0].value;

  // if it's my data or company
  const hideCardAndTreeView = [-12, -1].includes(selectedCohortId) || isCheckInView;

  const handleViewChange = useCallback(
    (view: OKRManageViewType) => {
      setViewType(view);
    },
    [setViewType]
  );

  const options = useMemo(() => {
    const dropdownOptions = [
      {
        label: 'List',
        value: 'list',
        onClick: () => handleViewChange('list'),
        Icon: FlatList,
      },
    ];

    if (!isGroupByIndividual && !isNetchexLogin) {
      dropdownOptions.push({
        label: 'List with hierarchy',
        value: 'listWithHierarchy',
        onClick: () => handleViewChange('listWithHierarchy'),
        Icon: CascadedList,
      });
    }

    if (!hideCardAndTreeView && !isGroupByIndividual) {
      dropdownOptions.push(
        {
          label: 'Card',
          value: 'card',
          onClick: () => handleViewChange('card'),
          Icon: CardView,
        },
        {
          label: 'Tree',
          value: 'tree',
          onClick: () => handleViewChange('tree'),
          Icon: TreeView,
        }
      );
    }

    return dropdownOptions;
  }, [handleViewChange, hideCardAndTreeView, isGroupByIndividual]);

  return options;
};
